import { render } from "./VirtualVisit.vue?vue&type=template&id=eab4cabc&ts=true"
import script from "./VirtualVisit.vue?vue&type=script&lang=ts"
export * from "./VirtualVisit.vue?vue&type=script&lang=ts"

import "./VirtualVisit.vue?vue&type=style&index=0&id=eab4cabc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__